/* eslint-disable no-console */
/**
 * Logger utility for consistent logging across the application
 * Supports different log levels: debug, info, warn, error
 */

const LEVELS = ['debug', 'info', 'warn', 'error'];

// Default level: in prod we only show warn+errors,
// in dev we show everything.
let currentLevel = process.env.NODE_ENV === 'production' ? 'warn' : 'debug';

/** Expose a console command to change log level at runtime */
if (typeof window !== 'undefined') {
  window.setLogLevel = level => {
    if (LEVELS.includes(level)) {
      currentLevel = level;
      console.info(`[logger] level set to ${level}`);
    } else {
      console.warn(`[logger] invalid level: ${level}`);
    }
  };
}

function shouldLog(level) {
  return LEVELS.indexOf(level) >= LEVELS.indexOf(currentLevel);
}

const logger = {
  debug: (...args) => {
    if (shouldLog('debug')) console.debug('[DEBUG]', ...args);
  },
  info: (...args) => {
    if (shouldLog('info')) console.info('[INFO]', ...args);
  },
  warn: (...args) => {
    if (shouldLog('warn')) console.warn('[WARN]', ...args);
  },
  error: (...args) => {
    if (shouldLog('error')) console.error('[ERROR]', ...args);
  },
};

export default logger;
